import EmptyListSearch from './EmptyListSearch';

export default EmptyListSearch;
